import { render } from "./VendedorDesempenho.vue?vue&type=template&id=6c4353f6"
import script from "./VendedorDesempenho.vue?vue&type=script&lang=js"
export * from "./VendedorDesempenho.vue?vue&type=script&lang=js"

import "./VendedorDesempenho.vue?vue&type=style&index=0&id=6c4353f6&lang=css"

import exportComponent from "C:\\raro\\raro-web\\argon-cel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__